// Engelsk oversættelse (reports): dansk tekst -> engelsk. Se ../index.js og I18N.md.
export default {
	"Tværprofilrapport": "Cross-section report",
	"Punktsky-baseret tværprofilanalyse": "Point cloud based cross-section analysis",
	"Genereret": "Generated",
	"Datakilde": "Data source",
	"Koordinatsystem": "Coordinate system",
	"Profilinterval": "Profile interval",
	"Profillængde": "Profile length",
	"Profilbånd": "Profile band",
	"Antal profiler": "Number of profiles",
	"Positiv retning er mod venstre set i forløbsretningen.": "Positive direction is to the left, seen in the direction of the route.",
	"Tværprofilrapport — {0} (fortsat)": "Cross-section report — {0} (continued)",
	"Luk": "Close",
	"IT_thirty four": "IT_thirty four",
	"Tværprofilrapport - {0}": "Cross-section report - {0}",
	"Eksportér til PDF": "Export to PDF",
	"Genererer PDF…": "Generating PDF…",
	"Tværprofilrapport - indstillinger": "Cross-section report - settings",
	"Angiv afstanden mellem profilerne langs forløbet, og hvor langt hvert profil skal strække sig på tværs.": "Enter the distance between the profiles along the route, and how far each profile should extend across it.",
	"Profillængde [m]": "Profile length [m]",
	"Angiv to positive tal.": "Enter two positive numbers.",
	"Generér profiler": "Generate profiles",
	"Profilinterval [m]": "Profile interval [m]",
	"Annuller": "Cancel",
	"Tværafstand (m)": "Cross distance (m)",
	"Ingen punkter fundet": "No points found",
	"1:1 (ingen højdeforstørrelse)": "1:1 (no height exaggeration)",
	"Højdeforstørrelse: {0}×": "Height exaggeration: {0}×",
	"Polygonen har ingen punkter.": "The polygon has no points.",
	"Polygonen skal have mindst 3 unikke punkter.": "The polygon must have at least 3 unique points.",
	"Polygonen har en degenereret (næsten nul-længde) kant ved punkt {0}.": "The polygon has a degenerate (almost zero-length) edge at point {0}.",
	"Polygonen har intet (eller forsvindende lille) areal i referenceplanet.": "The polygon has no (or a vanishingly small) area in the reference plane.",
	"Polygonen skærer sig selv og kan ikke bruges til arealberegning.": "The polygon intersects itself and cannot be used for area calculation.",
	"cellSize skal være positiv.": "cellSize must be positive.",
	"Randen skal have mindst 3 punkter.": "The boundary must have at least 3 points.",
	"Tidsudløb ved indlæsning af punktsky-node \"{0}\".": "Timeout while loading point cloud node \"{0}\".",
	"Mål areal og volumen understøtter i øjeblikket kun punktskyer uden rotation eller skalering (kun forskydning). Denne punktsky har en anden transformation og kan ikke måles korrekt med dette værktøj endnu.": "Measure area and volume currently only supports point clouds without rotation or scaling (translation only). This point cloud has a different transformation and cannot yet be measured correctly with this tool.",
	"Annulleret.": "Cancelled.",
	"Uventet Worker-fejl.": "Unexpected worker error.",
	"Worker-svaret kunne ikke læses (messageerror).": "The worker response could not be read (messageerror).",
	"Påfyldning: {0}": "Fill: {0}",
	"⚠ Ingen faktiske punktsky-observationer fundet inden for polygonen - resultatet viser derfor intet datadækket areal.": "⚠ No actual point cloud observations were found inside the polygon - the result therefore shows no data-covered area.",
	"Areal:": "Area:",
	"Påfyldning:": "Fill:",
	"Udgravning:": "Excavation:",
	"Dækning:": "Coverage:",
	"Mål areal og volumen": "Measure area and volume",
	"Referenceareal:": "Reference area:",
	"Datadækket areal:": "Data-covered area:",
	"Overfladeareal:": "Surface area:",
	"Netto:": "Net:",
	"Volumenbevægelse:": "Volume movement:",
	"Konvergens:": "Convergence:",
	"ikke beregnet (kun i standardflow)": "not calculated (standard flow only)",
	"Noder indlæst:": "Nodes loaded:",
	"Punkter i indlæste noder:": "Points in loaded nodes:",
	"Punkter efter bbox-filter:": "Points after bbox filter:",
	"Measurement-trekanter (understøttede):": "Measurement triangles (supported):",
	"Visual-trekanter (QA, fuld, ikke capped):": "Visual triangles (QA, full, not capped):",
	"Punkter inden for polygon:": "Points inside polygon:",
	"Reducerede observationer:": "Reduced observations:",
	"Referenceplan RMS:": "Reference plane RMS:",
	"Referenceplan hældning:": "Reference plane slope:",
	"Total beregningstid:": "Total calculation time:",
	"Rå punkter": "Raw points",
	"Punkter i polygon": "Points in polygon",
	"Reducerede punkter": "Reduced points",
	"Randpunkter": "Boundary points",
	"Trekanter": "Triangles",
	"Aktuelt trin": "Current step",
	"Grænse": "Limit",
	"Punktskyen har ingen punkter i det valgte niveau.": "The point cloud has no points at the selected level.",
	"Punktskyen har kun støjpunkter.": "The point cloud only has noise points.",
	"Beregner højdemodel ...": "Calculating height model ...",
	"Ingen celler har nok punkter (minimum {0} pr. {1} m celle) - punktskyen er for tynd i det valgte niveau.": "No cells have enough points (minimum {0} per {1} m cell) - the point cloud is too sparse at the selected level.",
	"Punktskyen er meget tynd (i gennemsnit {0} punkter pr. celle) - resultatet er usikkert.": "The point cloud is very sparse (on average {0} points per cell) - the result is uncertain.",
	"Rekonstruerer det oprindelige terræn ...": "Reconstructing the original terrain ...",
	"Finder udgravning og påfyldning ...": "Finding excavation and fill ...",
	"Annulleret": "Cancelled",
	"ukendt fejl i workeren": "unknown error in the worker",
	"Punktskyen er ikke klar (ingen oktræ-hierarki).": "The point cloud is not ready (no octree hierarchy).",
	"Der blev ikke hentet nogen punkter fra punktskyen.": "No points were fetched from the point cloud.",
	"Ikke fundet": "Not found",
	"Maks. dybde": "Max. depth",
	"Maks. højde": "Max. height",
	"Punktsky": "Point cloud",
	"Graverapport": "Excavation report",
	"Automatisk volumenberegning fra punktsky": "Automatic volume calculation from point cloud",
	"Projekt": "Project",
	"Cellestørrelse": "Cell size",
	"Oprindeligt terræn": "Original terrain",
	"Scanningens yderrand": "Outer edge of the scan",
	"Punkter anvendt": "Points used",
	"Oktræ-niveau": "Octree level",
	"{0} (ca. {1} punkter/m²)": "{0} (approx. {1} points/m²)",
	"Udgravning": "Excavation",
	"Påfyldning": "Fill",
	"Topbillede i punktskyens farver, nord op.": "Top view in the colors of the point cloud, north up.",
	"Dybde af udgravningen": "Depth of the excavation",
	"Højde af påfyldningen": "Height of the fill",
	"Metode": "Method",
	"Punktskyen er inddelt i et net af {0} m celler, hvor cellens højde er medianen af punkterne i cellen.": "The point cloud is divided into a grid of {0} m cells, where the height of a cell is the median of the points in the cell.",
	"Det oprindelige terræn er rekonstrueret som en jævn flade gennem punkter, der allerede er klassificeret som jord ({0} kontrolceller, renset for lokale afvigere).": "The original terrain is reconstructed as a smooth surface through points already classified as ground ({0} control cells, cleaned of local outliers).",
	"Punktskyen har for få jord-klassificerede punkter, så det oprindelige terræn er rekonstrueret ud fra den scannede flades yderrand.": "The point cloud has too few ground-classified points, so the original terrain is reconstructed from the outer edge of the scanned surface.",
	"Celler under det oprindelige terræn er udgravet materiale, celler over er påfyldt. For hver er det største sammenhængende område medtaget (mindste dybde {0} m), og volumen er summen af højdeforskellen gange celleareal.": "Cells below the original terrain are excavated material, cells above are fill. For each, the largest connected area is included (minimum depth {0} m), and the volume is the sum of the height difference times the cell area.",
	"Støjpunkter (klasse 7) er fjernet: {0}.": "Noise points (class 7) have been removed: {0}.",
	"Beregningen er udført på et grovere niveau af punktskyens oktræ (niveau {0}, {1} punkter, ca. {2} punkter pr. m²), så resultatet kan afvige nogle procent fra en beregning på fuld opløsning.": "The calculation was performed at a coarser level of the point cloud octree (level {0}, {1} points, approx. {2} points per m²), so the result may deviate a few percent from a calculation at full resolution.",
	"OBS: punktskyen er tyndere, end der er behov for til en sikker beregning (eller punktbudgettet er nået) - volumen kan afvige mere end normalt og bør kontrolleres.": "NOTE: the point cloud is sparser than needed for a reliable calculation (or the point budget has been reached) - the volume may deviate more than normal and should be checked.",
	"Åben": "Open",
	"I gang": "In progress",
	"Løst": "Resolved",
	"Ukendt": "Unknown",
	"Titel": "Title",
	"Kategori": "Category",
	"Status": "Status",
	"Ansvarlig": "Responsible",
	"Frist": "Due date",
	"(uden titel)": "(untitled)",
	"oprettet af {0}": "created by {0}",
	"Inspektionsrapport": "Inspection report",
	"POI'er fra PointView": "POIs from PointView",
	"Antal POI'er": "Number of POIs",
	"Udvalg": "Selection",
	"Der er ingen POI'er i udvalget.": "There are no POIs in the selection.",
	"Side {0} af {1}": "Page {0} of {1}",
	"Nr": "No.",
	"Detaljer": "Details",
	"Billeder": "Images",
	"Billeder fra punktskyen": "Images from the point cloud",
	"Egne billeder": "Own images",
	"Sted & link": "Place & link",
	"(forfalden)": "(overdue)",
	"Position (x, y, z)": "Position (x, y, z)",
	"Link": "Link",
	"Profilrapport.pdf": "Cross_section_report.pdf",
	"Profilrapport_{0}.pdf": "Cross_section_report_{0}.pdf",
};
